<script setup lang="ts">
  import { estimation, values } from '@/apps/website/pages/reserve';
  import { euro } from '@/services/currency';
  import type { Location } from '@/types/location';
  import { computed } from 'vue';

  const props = defineProps<{
    location: Location;
  }>();

  const selectedSpace = computed(() => {
    if (!values.form.value.space_id) return null;

    return props.location.spaces.find((space) => space.id === values.form.value.space_id);
  });
</script>
<template>
  <ul v-if="selectedSpace">
    <li>
      <span>Kosten zaalhuur</span>
      <span> {{ euro.format(estimation?.total_fixed ?? 0) }}</span>
    </li>

    <li>
      <span
        >{{ euro.format(estimation?.price_per_person ?? 0) }} x
        <span v-if="values.form.value.estimated_persons < selectedSpace.persons_min">{{ selectedSpace.persons_min }} personen (minimaal)</span>
        <span v-else>{{ values.form.value.estimated_persons }} personen</span>
      </span>
      <span>{{ euro.format(estimation?.total_per_person ?? 0) }}</span>
    </li>
    <li v-if="estimation?.total_products && estimation.total_products > 0">
      <span>Extra opties</span>
      <span>{{ euro.format(estimation.total_products) }}</span>
    </li>
    <li v-if="estimation?.total_discount && estimation.total_discount > 0">
      <span>Korting</span>
      <span>- {{ euro.format(estimation.total_discount) }}</span>
    </li>
  </ul>
</template>
